export const bombZaps = [
  {
    zapAddress: '0xB0E16f8ca644Da5391721CD83F395fe1217aFCFF',
    ammRouter: '0x32aca4019C8A0466745c6661f33bEeA4653EE1b1',
    ammFactory: '0x7A2BBB0d1644eCD88DE99E3fAd82291199703AB9',
    ammPairInitHash: '0x3aca680dfae9368cd4d940874467a257013598740dbdb91632aeece030d587a3',
  },
];
